export enum EDuree {
	jour = "jour(s)",
	mois = "mois",
	dates = "dates",
	jusquADate = "jusquADate"
}